import React, { useEffect, useRef, useState } from 'react';
import './StatusFilterDropdown.css';

function OwnerFilterDropdown(props) {
	const {
		onFilter,
		filteredOwner,
		owners,
		isDisabled,
	} = props;

	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleSelect = (owner) => {
		onFilter(owner);
		setIsOpen(false);
	};

	const getDisplayText = (owner) => {
		if (!owner || owner === 'all') return 'All';
		return owner;
	};

	const getButtonClass = () => {
		if (!filteredOwner || filteredOwner === 'all') return 'btn-success';
		return 'btn-primary';
	};

	return (
		<div className="status-filter-dropdown" ref={dropdownRef}>
			<button
				disabled={isDisabled}
				className={`filter-button btn btn-sm ${getButtonClass()} dropdown-toggle px-2`}
				onClick={() => setIsOpen(!isOpen)}
			>
				Owner: {getDisplayText(filteredOwner)}
				<span className="caret"></span>
			</button>
			{isOpen && (
				<div className="status-filter-menu">
					<div
						className={`status-filter-item ${filteredOwner === 'all' ? 'active' : ''}`}
						onClick={() => handleSelect('all')}
					>
						All
					</div>
					{owners.map((owner) => (
						<div
							key={owner}
							className={`status-filter-item ${filteredOwner === owner ? 'active' : ''}`}
							onClick={() => handleSelect(owner)}
						>
							{owner}
						</div>
					))}
				</div>
			)}
		</div>
	);
}

export default OwnerFilterDropdown;
